import { CircularProgress } from "@mui/material";
import React from "react";

export const PrimaryButton = ({ text, loading, action, disabled }) => {
  return (
    <div
      onClick={disabled ? () => {} : action}
      className={`${
        disabled ? "bg-[#D5F6EE]" : "bg-primary"
      } cursor-pointer uppercase font-body text-center text-white py-3 w-full rounded-md text-sm mx-auto transition-all duration-500`}
    >
      {loading ? (
        <CircularProgress size={20} style={{ color: "white" }} />
      ) : (
        text
      )}
    </div>
  );
};
